import React, { Fragment } from "react";
import { Col, FormGroup, Label, Row, Table } from "reactstrap";

export const SellerShopifyDetails = (props) => {
    const { errors, register, trigger, setValue, getValues } = props;

    const enableShopifyIntegration = !!getValues("enableShopifyIntegration");
    const shopifyAppType = getValues("shopifyAppType") || "legacy";

    const clearShopifyFields = () => {
        setValue("storeName", "");
        setValue("apiKey", "");
        setValue("apiSecretKey", "");
        setValue("secretKey", "");
    };

    const onToggleEnable = (e) => {
        const checked = e.target.checked;
        setValue("enableShopifyIntegration", checked);

        // optional: keep shopifyAppType as-is or set default
        /*if (!checked) {
            setValue("shopifyAppType", "legacy");
            clearShopifyFields();
        }*/

        trigger([
        "enableShopifyIntegration",
        "shopifyAppType",
        "storeName",
        "apiKey",
        "apiSecretKey",
        "secretKey",
        ]);
    };

    const onChangeAppType = (e) => {
        const val = e.target.value;
        setValue("shopifyAppType", val);
        trigger(["shopifyAppType", "storeName", "apiKey", "apiSecretKey", "secretKey"]);
    };
    
    return (
        <Fragment>
            <Row>
                <Col md={12}>
                    <FormGroup>
                        <div className="form-check">
                        <input
                            id="enableShopifyIntegration"
                            type="checkbox"
                            className="form-check-input"
                            {...register("enableShopifyIntegration")}
                            checked={enableShopifyIntegration}
                            onChange={onToggleEnable}
                        />
                        <Label className="form-check-label" for="enableShopifyIntegration">
                            Enable Shopify Integration
                        </Label>
                        </div>
                    </FormGroup>
                    </Col>

                    {enableShopifyIntegration && (
                    <>
                        <Col md={12}>
                        <FormGroup>
                            <Label className="form-label">
                            App Type <span style={{ color: "red" }}>*</span>
                            </Label>

                            <div className="d-flex" style={{ gap: 20 }}>
                            <div className="form-check">
                                <input
                                id="shopifyAppType-legacy"
                                type="radio"
                                name="shopifyAppType"
                                value="legacy"
                                className="form-check-input"
                                {...register("shopifyAppType")}
                                checked={shopifyAppType === "legacy"}
                                onChange={onChangeAppType}
                                />
                                <Label className="form-check-label" for="shopifyAppType-legacy">
                                Shopify Legacy App
                                </Label>
                            </div>

                            <div className="form-check">
                                <input
                                id="shopifyAppType-new"
                                type="radio"
                                name="shopifyAppType"
                                value="new"
                                className="form-check-input"
                                {...register("shopifyAppType")}
                                checked={shopifyAppType === "new"}
                                onChange={onChangeAppType}
                                />
                                <Label className="form-check-label" for="shopifyAppType-new">
                                Shopify New App
                                </Label>
                            </div>
                            </div>

                            <div className="text-danger" style={{ fontSize: 12 }}>
                            {errors.shopifyAppType?.message}
                            </div>
                        </FormGroup>
                        </Col>

                        <Col md={12}>
                        <FormGroup>
                            <Label className="form-label">
                            Store Name <span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                            name="storeName"
                            type="text"
                            className={`form-control ${errors.storeName ? "is-invalid" : ""}`}
                            placeholder="example.myshopify.com"
                            {...register("storeName")}
                            />
                            <div className="invalid-feedback">{errors.storeName?.message}</div>
                        </FormGroup>
                        </Col>

                        <Col md={6}>
                        <FormGroup>
                            <Label className="form-label">
                            {shopifyAppType === "new" ? "Client ID" : "API Key"}{" "}
                            <span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                            name="apiKey"
                            type="text"
                            className={`form-control ${errors.apiKey ? "is-invalid" : ""}`}
                            {...register("apiKey")}
                            />
                            <div className="invalid-feedback">{errors.apiKey?.message}</div>
                        </FormGroup>
                        </Col>

                        <Col md={6}>
                        <FormGroup>
                            <Label className="form-label">
                            {shopifyAppType === "new" ? "Secret" : "API Secret Key"}{" "}
                            <span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                            name="apiSecretKey"
                            type="text"
                            className={`form-control ${errors.apiSecretKey ? "is-invalid" : ""}`}
                            {...register("apiSecretKey")}
                            />
                            <div className="invalid-feedback">{errors.apiSecretKey?.message}</div>
                        </FormGroup>
                        </Col>

                        {shopifyAppType === "legacy" && (
                        <Col md={12}>
                            <FormGroup>
                            <Label className="form-label">
                                Access Token <span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                                name="secretKey"
                                type="text"
                                className={`form-control ${errors.secretKey ? "is-invalid" : ""}`}
                                {...register("secretKey")}
                            />
                            <div className="invalid-feedback">{errors.secretKey?.message}</div>
                            </FormGroup>
                        </Col>
                        )}

                        <Col md={12} className="mt-3">
                            <h4 style={{marginBottom: 50}}>Permission required while creating custom app at Shopify Admin</h4>
                            <span style={{fontWeight: "bold"}}>Below permissions are required to integrate your store with our system. Please make sure all permission are assigned. Any missing permission may result in unexpected behavior or errors</span>

                            <Table bordered style={{marginTop:50}}>
                                <thead>
                                <tr>
                                    <th style={{ borderBottom: '1px solid #e8eaed', borderTop: '1px solid #e8eaed',borderLeft: 'white', borderRight: 'white' }}>Operation</th>
                                    <th style={{ borderBottom: '1px solid #e8eaed', borderTop: '1px solid #e8eaed',borderLeft: 'white', borderRight: 'white' }}>Permissions</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>Read Products from Seller Store</td>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>read_products</td>
                                </tr>
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>Read Inventory from Seller Store</td>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>read_inventory</td>
                                </tr>
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>Read Orders from Seller Store</td>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>read_orders</td>
                                </tr>
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>Create Orders in Seller Store</td>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>write_orders</td>
                                </tr>
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>Read Fulfilments from Seller Store</td>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>
                                        read_assigned_fulfillment_orders<br/>
                                        read_merchant_managed_fulfillment_orders<br/>
                                        read_fulfillments
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>Fulfil Order in Seller Store</td>
                                    <td style={{ borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' }}>
                                        write_assigned_fulfillment_orders<br/>
                                        write_merchant_managed_fulfillment_orders
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </Col>
                        
                        <Col md={12} className="mt-4">
                            <a
                                href="https://storage.googleapis.com/qa_goddiva_market_place/upload/Shopify_Custom_App_Guide_Goddiva.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                                className="btn btn-info btn-sm"
                                style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}
                            >
                                <i className="icofont icofont-download"></i>
                                Download Shopify Custom App Guide
                            </a>
                        </Col>
                    </>
                )}
            </Row>
        </Fragment>
    )
}